<template>
    <el-form :model="formPlan" ref="formPlan" :label-position="'top'">
        <el-form-item class="custom-label"
            label="Selecciona tu fecha de visita y tus artículos de interés"
            prop="fecha_visita"
            :rules="[
                { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
            ]">
            <el-date-picker
                v-model="formPlan.fecha_visita"
                type="date"
                placeholder="Seleccione un día"
                format="dd/MM/yyyy"
                @change="getTickets"
                class="w-100"
                :picker-options="pickerOptions">
            </el-date-picker>
        </el-form-item>

        <el-alert v-if="listTickets.length == 0 && formPlan.fecha_visita != null"
            title="No se encontrarón productos disponibles para la fecha seleccionada" type="error" class="mb-4">
        </el-alert>

        <!--Entradas pagadas-->
        <div v-if="listTickets.length > 0" class="row mt-4">
            <div class="col-sm-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="th">Tipo de entrada</th>
                            <th scope="col" class="th" style="width:80px;">Precio</th>
                            <th scope="col" class="th"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in listTickets" :key="index">
                            <td>{{ item.productoDescripcion }}</td>
                            <td>s/ {{ item.pUnitario.toFixed(2) }}</td>
                            <td>
                                <el-button type="success" round size="small" icon="el-icon-shopping-cart-2"
                                    class="btn-block" @click="agregar(item)">Agregar</el-button>
                            </td>
                        </tr>

                        <tr v-for="(item, index) in listTicketsFree" :key="index">
                            <td>{{ item.productoDescripcion }}</td>
                            <td>s/ {{ item.pUnitario.toFixed(2) }}</td>
                            <td>
                                <el-button type="success" round size="small" icon="el-icon-shopping-cart-2"
                                    class="btn-block" @click="agregar(item)">Agregar</el-button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>


        <!--<button v-if="listPiscinas.length>0" class="btn btn-warning mb-3 mt-3 ml-2" style="border-radius:50px" @click.prevent="dialogServices = true">+ Agregar servicios</button>
        -->

        <div class="text-right">
            <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">Atras</button>
            <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formPlan')">Siguiente</button>
        </div>



        <el-dialog :visible.sync="dialogVisible" width="30%" center>
            <p>
                ¿Desea agregar <b>{{ item.productoDescripcion }}</b> a su carrito de compras?
            </p>
            <div class="row">
                <div class="col-sm-5">
                    <label>Por favor ingrese la cantidad</label>
                </div>
                <div class="col-sm-7">
                    <el-input-number v-model="numero" :min="1" :max="20"></el-input-number>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <button class="btn mb-3 mt-3 ml-2" @click.prevent="dialogVisible = false">Cancelar</button>
                <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="addCarrito">Si, agregar</button>
            </span>
        </el-dialog>

        <el-dialog title="Agregar servicios adicionales a mi compra" :visible.sync="dialogServices" width="50%"
            @opened="openedServices">
            <!--<el-alert title="Seleccione un turno haciendo clic en la opción [Agregar]" type="success" show-icon class="mb-3">
        </el-alert>-->
            <div class="row">
                <label class="col-sm-3"><b>Fecha de visita:</b> </label>
                <label class="col-sm-9 text-primary font-weight-bold h5">{{ getDateVisit }} </label>
            </div>
            <hr>
            <div class="row">
                <el-tabs :tab-position="'left'" style="height: 200px;">
                    <el-tab-pane>
                        <div class="d-flex flex-column align-items-center" slot="label">
                            <img :src="'/static/logos/iconpiscina.png'" width="auto" height="80" alt="logo">
                            <!--<i class="el-icon-date"></i>-->
                            <span>Piscina</span>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="th">Servicio</th>
                                    <th scope="col" class="th" style="width:80px;">Precio</th>
                                    <th scope="col" class="th">Opción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in listPiscinas" :key="index">
                                    <td>{{ item.productoDescripcion }}</td>
                                    <td>s/ {{ item.pUnitario.toFixed(2) }}</td>
                                    <td>
                                        <el-button type="success" round size="small" icon="el-icon-shopping-cart-2"
                                            class="btn-block" @click="agregar(item)">Agregar</el-button>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </el-tab-pane>
                    <!--<el-tab-pane label="Config">Config</el-tab-pane>-->
                </el-tabs>
            </div>

            <!--<div class="row">
            <label class="col-sm-3"><b>Servicio de piscina:</b> </label>
            <el-select v-model="piscinaId" placeholder="Seleccione" size="small" class="col-sm-9">
                <el-option v-for="(item, index) in listPiscinas" :key="'P'+index" :label="item.productoDescripcion" :value="item.productoId"></el-option>
            </el-select>
        </div>-->

            <!--<table class="table table-bordered mt-4">
            <colgroup>
                <col class="col-sm- col-md-2">
                <col class="col-md-3">
                <col class="col-md-3">
                <col class="col-md-2">
                <col class="col-md-2">
            </colgroup>
            <tr class="bg-gray-100 text-center">
                <th class="align-middle">Turno</th>
                <th>Inicia</th>
                <th>Termina</th>
                <th>Aforo</th>
                <th>***</th>
            </tr>
            <tbody>
                <tr v-for="(item,index) in listTurnos" :key="'S'+index">
                    <td>{{item.item}}</td>
                    <td>{{item.horaInicio}}</td>
                    <td>{{item.horaFin}}</td>
                    <td>{{item.disponible}} de {{item.aforo}}</td>
                    <td>
                        <el-button type="success" round size="small" icon="el-icon-shopping-cart-2" class="btn-block" @click="agregar(item)">Agregar</el-button>
                    </td>
                </tr>
            </tbody>
        </table>-->

        </el-dialog>

    </el-form>
</template>

<script>
//services
import services from "@/services/services.service";
import moment from "moment";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

import {
    mapGetters
} from 'vuex'

export default {
    props: {
        club: {
            type: Object,
            required: true,
            default: {}
        },
        op: {
            type: null,
            required: true,
            default: null
        }
    },
    data: () => ({
        formPlan: {
            fecha_visita: null,
        },
        listTickets: [],
        listCarrito: [],
        listTurnos: [],
        listPiscinas: [],
        piscinaId: null,
        dialogVisible: false,
        numero: 1,
        item: {},
        isFree: false,
        listTicketsFree: [],
        dialogServices: false,
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() < Date.now() - 86400000; // Deshabilita fechas anteriores a hoy
            }
        }
    }),
    computed: {
        ...mapGetters(['totalPagar', 'getDateVisit'])

    },
    methods: {
        volver() {
            this.$emit("resVolver", 1)
        },

        async getTickets() {

            let hoy = moment().format('YYYY-MM-DD')
            let current = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD')

            if (current < hoy) {
                this.formPlan.fecha_visita = null
                this.listTickets = []
                this.listTicketsFree = []
                this.$notify.error({ title: 'Error', message: 'No puede seleccionar una fecha anterior.' });

            } else {

                if (current == '2024-08-18' && this.club.idseat == '00025') {
                    alert("Lo sentimos, en esta fechas no atenderemos. Gracias por tu comprensión")
                    this.formPlan.fecha_visita = null
                    this.listTickets = []
                    this.listTicketsFree = []
                    return false
                }



                if (current == '2023-12-24' || current == '2023-12-31') {
                    this.$notify.error({ title: 'Error', message: 'Lo sentimos, en estas fechas no atenderemos. Gracias por tu comprensión' });
                    this.formPlan.fecha_visita = null
                    this.listTickets = []
                    this.listTicketsFree = []
                    return false
                }

                let date_visit = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD[T]00:00:00')
                this.listTickets = []
                this.listCarrito = []
                this.listTicketsFree = []

                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

                //entradas pagadas
                await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "001",
                    "inicio": date_visit,
                    "origen": "ANDROID",
                    "op": null

                }).then((res) => {
                    this.listTickets = res.data;

                    if(this.club.idseat == '00040'){
                        this.listTickets = res.data.filter(item =>
                            ![1,2,3,4,5].includes(item.dia)
                        );
                    } else {
                        this.listTickets = res.data.filter(item => {
                            // Si la categoría es 008, filtra días 0, 6 y 7
                            if (item.categoriaId === '008' && ['00018', '00024', '00020', '00025', '00030'].includes(this.club.idseat)) {
                                return ![0, 6, 7].includes(item.dia);
                            }

                            // Para cualquier otra categoría, no aplicar filtro
                            return true;
                        });
                    }
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })

                //vaidar si tiene piscina paraquitarlo siempre y cuando no sea la fecha y los parques
                /*
                const diasPermitidos = [18, 19, 20, 25, 26, 27];
                const areasControladas = ['00027', '00018', '00020', '00030', '00024', '00025'];

                // Simulamos que esta es la fecha actual (viene en formato ISO)
                const fechaActualStr = date_visit; // Ejemplo: desde el backend o algún input

                // Extraemos el día y mes
                const fecha = new Date(fechaActualStr);
                const dia = fecha.getDate();
                const mes = fecha.getMonth() + 1; // getMonth() devuelve 0 para enero, 3 para abril

                this.listTickets = this.listTickets.filter(item => {
                  const descripcion = item.productoDescripcion.toLowerCase();
                  const contienePiscina = descripcion.includes('piscina');

                 // Si el área no es controlada, no se aplica restricción
                    if (!areasControladas.includes(item.areaId)) return true;

                  // Si contiene piscina y no estamos en los días válidos de abril
                  if (contienePiscina && mes === 4 && !diasPermitidos.includes(dia)) {
                    return false; // eliminar del array
                  }

                  return true;
                });
                */


                //entradas gratis
                await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "006",
                    "inicio": date_visit
                }).then((res) => {
                    this.listTicketsFree = res.data
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })

                //piscina
                /*await axios.post(`${process.env.API2}/v1/cc/result3`, {
                    "ue": "001066",
                    "sede": this.club.idseat,
                    "areaId": this.club.idseat,
                    "categoriaId": "008",
                    "inicio": date_visit
                }).then((res) => {
                    //this.listPiscinas = res.data;
                    this.listPiscinas = res.data.filter(item =>
                        ![0,6,7].includes(item.dia)
                    );
                }).catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })
                */

                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");

                this.$store.dispatch("updateDateVisit", moment(date_visit).format('DD/MM/YYYY'));
                this.$store.dispatch("updateCarrito", this.listCarrito);

            }

        },

        async openedServices() {
            //estableciendo el primer registro en el select
            if (this.listPiscinas.length > 0) {
                this.piscinaId = this.listPiscinas[0].productoId
            }

            //consultar turnos
            let fechaInicio = moment(this.formPlan.fecha_visita).format('YYYY-MM-DD[T]00:00:00')
            await axios.post(`${process.env.API2}/v1/piscina/listarProgramacion`, {
                "ue": "001066",
                "sede": "001",
                "area": this.club.idseat,
                "fechaInicio": fechaInicio
            }).then((res) => {
                this.listTurnos = res.data
            })
        },

        agregar(item) {
            this.item = item
            this.numero = 0

            /*if (this.dialogServices) {

                let itemPiscina = this.listPiscinas.filter(param => param.productoId === this.piscinaId)
                let selectItem = Object.assign({}, ...itemPiscina)

                this.item.productoId = item.codigo
                this.item.productoDescripcion = selectItem.productoDescripcion + " | turno " + item.item + " de " + item.horaInicio + " a " + item.horaFin
                this.item.pUnitario = selectItem.pUnitario
            }*/

            this.dialogVisible = true
        },

        addCarrito() {
            if (this.numero > 0) {
                /*let _codigo = null
                let _turno = null

                if (this.dialogServices) {
                    _codigo = this.item.productoId
                    _turno = this.item.item
                }*/
                //console.log(this.item.category)

                let tmpcar = {
                    item: (this.listCarrito.length + 1),
                    areaId: this.club.idseat,
                    producto: this.item.productoId,
                    descripcionProducto: this.item.productoDescripcion,
                    precioUnitario: this.item.pUnitario,
                    cantidad: this.numero,
                    total: (parseFloat(this.item.pUnitario) * parseInt(this.numero)),
                    ordercategory: this.item.category
                    /*codigo: _codigo,
                    turno: _turno*/
                }
                this.listCarrito.push(tmpcar)
                this.$store.dispatch("updateCarrito", this.listCarrito);
                //console.log(this.listCarrito)
            }
            this.dialogVisible = false
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false

                if (this.listCarrito.length > 0) {
                    if (this.totalPagar <= 0)
                        this.$notify.error({ title: 'Error', message: 'El monto no puede 0' });
                    else
                        this.$emit('resCarrito', this.listCarrito)
                } else
                    this.$notify.error({ title: 'Error', message: 'Su carrito se encuentra vacío, por favor agrege productos a su cesta.' });
            })
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/entradas/Tickets.vue